/* tslint:disable:max-line-length */
import {FuseNavigationItem} from '@fuse/components/navigation';
import {Roles} from "../../constants/roles";
import {SetupType} from "../../constants/setup-type";

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'mat_outline:dashboard',
        link: '/dashboard',
        classes: {
            icon: 'icon-size-4'
        }
    },
    {
        id: 'reviews',
        title: 'Collect Reviews',
        type: 'aside',
        icon: 'mat_outline:send',
        classes: {
            icon: 'icon-size-4'
        },
        children: [
            {
                id: 'review-requests',
                title: 'Review Requests',
                type: 'group',
                children: [
                    {
                        id: 'review-invites',
                        title: 'Enroll Customers',
                        subtitle: 'Add customers to a sequence',
                        icon: 'heroicons_outline:plus',
                        type: 'basic',
                        link: '/collect-review/invite-customer'
                    },
                    {
                        id: 'sequences',
                        title: 'Sequences',
                        subtitle: 'Create automated multi-step outreach',
                        icon: 'heroicons_outline:refresh',
                        type: 'basic',
                        link: '/collect-review/sequence'
                    }
                ]
            },
            {
                id: 'customer-management',
                title: 'Customer Management',
                type: 'group',
                children: [
                    {
                        id: 'customers',
                        title: 'Customers',
                        subtitle: 'Manage customer records and contact details',
                        icon: 'heroicons_outline:user',
                        type: 'basic',
                        link: '/collect-review/customer'
                    },
                    {
                        id: 'customer-groups',
                        title: 'Customer Groups',
                        subtitle: 'Organize customers into reusable groups',
                        icon: 'heroicons_outline:user-group',
                        type: 'basic',
                        link: '/collect-review/customer-groups'
                    }
                ]
            },
            {
                id: 'collection-tools',
                title: 'Collection Tools',
                type: 'group',
                children: [
                    {
                        id: 'review-survey-links',
                        title: 'Review & Survey Links',
                        subtitle: 'Create review, NPS, CSAT, and survey links',
                        icon: 'heroicons_outline:link',
                        type: 'basic',
                        link: '/collect-review/funnel-page',
                        roleType: [Roles.SUPER_ADMIN]
                    },
                    {
                        id: 'experience-drivers',
                        title: 'Feedback Categories',
                        subtitle: 'Configure reasons behind customer sentiment',
                        icon: 'heroicons_outline:chart-pie',
                        type: 'basic',
                        link: '/collect-review/experience-drivers',
                        roleType: [Roles.SUPER_ADMIN]
                    },
                    {
                        id: 'configurations',
                        title: 'Configurations',
                        subtitle: 'Customise your review requests',
                        icon: 'feather:aperture',
                        type: 'basic',
                        link: '/collect-review/configurations',
                        setupType: [SetupType.LOCAL]
                    },
                    {
                        id: 'qr-codes',
                        title: 'QR Codes',
                        subtitle: 'Create QR codes for in-store review collection',
                        icon: 'heroicons_outline:qrcode',
                        type: 'basic',
                        link: '/collect-review/qr-code'
                    }
                ]
            }
        ]
    },
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'aside',
        icon: 'heroicons_outline:chart-bar',
        classes: {
            icon: 'icon-size-4'
        },
        children: [
            {
                id: 'review-analytics',
                title: 'Review',
                subtitle: 'Review Analytics',
                icon: 'mat_outline:stars',
                type: 'basic',
                link: '/analytics/review'
            },
            {
                id: 'Sequence-analytics',
                title: 'Sequence',
                subtitle: 'Sequence Analytics',
                icon: 'mat_outline:campaign',
                type: 'basic',
                link: '/analytics/sequence'
            },
            {
                id: 'invite-review-ratio',
                title: 'Invite Review Ratio',
                subtitle: 'Invite Review Ratio Analytics',
                icon: 'mat_solid:insert_chart_outlined',
                type: 'basic',
                link: '/analytics/invite-review-ratio'
            },
            {
                id: 'channel-based',
                title: 'Channel Based Analytics',
                subtitle: 'Channel Based Analytics',
                icon: 'mat_solid:pie_chart',
                type: 'basic',
                link: '/analytics/channel-based'
            },
            {
                // Children filled at runtime from luzmo/assets (see injectLuzmoAssetsIntoNavigation).
                id: 'luzmo-reports',
                title: 'BI Dashboard',
                icon: 'heroicons_outline:presentation-chart-bar',
                type: 'collapsable',
                classes: {
                    wrapper: 'luzmo-bi-section'
                },
                children: []
            }
            // {
            //     id: 'fresh-feedback',
            //     title: 'Survey Performance',
            //     subtitle: 'Survey Performance',
            //     icon: 'heroicons_outline:clipboard-list',
            //     type: 'basic',
            //     link: '/analytics/fresh-feedback',
            //     hidden: () => true
            // },
            // {
            //     id: 'cx-feedback-by-category',
            //     title: 'Service & Product Insights',
            //     subtitle: 'Service & Product Insights',
            //     icon: 'heroicons_outline:presentation-chart-bar',
            //     type: 'basic',
            //     link: '/analytics/cx-feedback-by-category',
            //     hidden: () => true
            // },
            // {
            //     id: 'cx-analytics',
            //     title: 'CX Overview',
            //     subtitle: 'CX Overview',
            //     icon: 'heroicons_outline:presentation-chart-line',
            //     type: 'basic',
            //     link: '/cx-analytics',
            //     hidden: () => true
            // }
        ]
    },
    {
        id: 'monitor',
        title: 'Google Reviews',
        type: 'basic',
        icon: 'heroicons_outline:annotation',
        classes: {
            icon: 'icon-size-4'
        },
        link: '/monitor-reviews/my-reviews',
        orgKey: 'monitorReviews'
    },
    {
        id: 'display',
        title: 'Review Marketing',
        type: 'aside',
        icon: 'mat_outline:star_outline',
        classes: {
            icon: 'icon-size-4'
        },
        children: [
            {
                id: 'navigation-features.level.0.1-1',
                title: 'Google Widgets and Badges',
                subtitle: 'Embed & showcase reviews',
                icon: 'mat_outline:widgets',
                type: 'basic',
                link: '/review-marketing/review-widget',
                hideOnMobile: true
            },
            {
                id: 'navigation-features.level.0.1-3',
                title: 'Microsite',
                subtitle: 'Micro-site showcasing reviews',
                icon: 'mat_outline:phonelink',
                type: 'basic',
                link: '/review-marketing/micro-site'
            },
            {
                id: 'navigation-features.level.0.1-2',
                title: 'Configurations',
                subtitle: 'Engage Audiences with Posts & Videos',
                icon: 'feather:aperture',
                type: 'basic',
                link: '/review-marketing/configurations'
            }
        ]
    },
    {
        id: 'integration',
        title: 'Integrations',
        type: 'aside',
        icon: 'heroicons_outline:puzzle',
        classes: {
            icon: 'icon-size-4'
        },
        roleType: [Roles.SUPER_ADMIN],
        children: [
            {
                id: 'native',
                title: 'Native',
                subtitle: 'Native Integrations',
                icon: 'heroicons_outline:link',
                type: 'basic',
                link: '/integrations/native'
            },
            {
                id: 'zapier',
                title: 'Zapier',
                subtitle: 'Zapier Integrations',
                icon: 'heroicons_outline:link',
                type: 'basic',
                link: '/integrations/zapier'
            },
            {
                id: 'webhook-logs',
                title: 'Webhook Logs',
                subtitle: 'Webhook Invocation Logs',
                icon: 'heroicons_outline:document-text',
                type: 'basic',
                link: '/integrations/webhook-logs'
            }

        ]
    },
    {
        id: 'settings',
        title: 'Advanced Settings',
        type: 'aside',
        icon: 'heroicons_solid:cog',
        classes: {
            icon: 'icon-size-4'
        },
        roleType: [Roles.SUPER_ADMIN, Roles.ADMIN],
        meta: {settingsAside: true},
        children: [
            {
                id: 'organisation',
                title: 'Organisation',
                type: 'group',
                children: [
                    {
                        id: 'manage-location',
                        title: 'Locations',
                        subtitle: 'Add and manage business locations',
                        icon: 'heroicons_outline:map',
                        type: 'basic',
                        link: '/agency-mode/manage-location',
                        roleType: [Roles.SUPER_ADMIN],
                    },
                    {
                        id: 'manage-user',
                        title: 'Users & Access',
                        subtitle: 'Manage users, roles, and location access',
                        icon: 'heroicons_outline:user-group',
                        type: 'basic',
                        link: '/agency-mode/user-list',
                        roleType: [Roles.SUPER_ADMIN, Roles.ADMIN],
                    }
                ]
            },
            {
                id: 'communication-providers',
                title: 'Communication Providers',
                type: 'group',
                children: [
                    {
                        id: 'custom-provider',
                        title: 'Email Provider',
                        subtitle: 'Configure the email delivery provider',
                        icon: 'mat_outline:mail',
                        type: 'basic',
                        link: '/agency-mode/email-provider',
                        roleType: [Roles.SUPER_ADMIN]
                    },
                    {
                        id: 'sms-provider',
                        title: 'SMS Provider',
                        subtitle: 'Configure the SMS delivery provider',
                        icon: 'mat_outline:sms',
                        type: 'basic',
                        link: '/agency-mode/sms-provider',
                        roleType: [Roles.SUPER_ADMIN],
                        orgKey: 'smsProviderEnabled'
                    },
                    {
                        id: 'whatsapp-provider',
                        title: 'WhatsApp Provider',
                        subtitle: 'Configure the WhatsApp Business provider',
                        icon: 'mat_outline:sms',
                        type: 'basic',
                        link: '/agency-mode/whatsapp-provider',
                        roleType: [Roles.SUPER_ADMIN]
                    }
                ]
            },
            {
                id: 'ai-configuration',
                title: 'AI Configuration',
                type: 'group',
                children: [
                    {
                        id: 'openai-provider',
                        title: 'AI Provider',
                        subtitle: 'Configure the AI provider used for review responses',
                        icon: 'heroicons_outline:sparkles',
                        type: 'basic',
                        link: '/agency-mode/open_ai-provider',
                        roleType: [Roles.SUPER_ADMIN],
                        orgKey: 'openAiProviderEnabled'
                    }
                ]
            },
            {
                id: 'branding-domain',
                title: 'Branding & Domain',
                type: 'group',
                children: [
                    {
                        id: 'email-setup',
                        title: 'Custom Domain',
                        subtitle: 'Use your own domain for review and survey links',
                        icon: 'heroicons_outline:globe',
                        type: 'basic',
                        link: '/custom-domain/domain-list',
                        orgKey: 'customDomainEnabled',
                        roleType: [Roles.SUPER_ADMIN],
                    },
                    {
                        id: 'white-label',
                        title: 'White Label',
                        subtitle: 'Configure product and customer-facing branding',
                        icon: 'mat_outline:palette',
                        type: 'basic',
                        link: '/agency-mode/white-label',
                        roleType: [Roles.SUPER_ADMIN],
                        orgKey: 'whitelabelEnabled'
                    }
                ]
            },
            {
                id: 'global-configuration',
                title: 'Global Configuration',
                type: 'group',
                children: [
                    {
                        id: 'head-office-configuration',
                        title: 'Head Office Settings',
                        subtitle: 'Define global defaults and policies for all locations',
                        icon: 'heroicons_outline:office-building',
                        type: 'basic',
                        link: '/agency-mode/head-office-configuration',
                        roleType: [Roles.SUPER_ADMIN],
                        setupType: [SetupType.GLOBAL, SetupType.SHARED]
                    }
                ]
            },
            {
                id: 'subscription',
                title: 'Subscription',
                subtitle: 'Manage Subscription',
                icon: 'mat_outline:inventory',
                type: 'basic',
                link: '/agency-mode/pricing',
                roleType: [Roles.SUPER_ADMIN],
                hideOnMobile: true,
                hideOnSubscription: true

            }
        ]
    }
];
